import React from "react";
import { Layout } from "../../common/Layout/Layout";
import { StaysForm } from "./StaysForm/StaysForm";

export const CreateOrEditStay = () => {
  return (
    <Layout>
      <StaysForm />
    </Layout>
  );
};
